var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mediaInfo.isShow)?_c('div',{staticClass:"video-box",on:{"click":_vm.$goFundApp}},[_c('img',{staticClass:"video-img",attrs:{"src":_vm.mediaInfo.media.pic}}),_c('img',{staticClass:"play-btn",attrs:{"src":_vm.playBtn}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }